export const fabricIconsByTypeTop100: Record<string, string> = {
  // Core
  fabric_capacity:            "/icons/fabric/fabric_capacity.svg",
  fabric_workspace:           "/icons/fabric/group_workspace_64_non-item.svg",
  fabric_folder:              "/icons/fabric/folder_64_non-item.svg",
  fabric_deployment_pipeline: "/icons/fabric/copy_job_64_item.svg",
  // Data
  fabric_lakehouse:           "/icons/fabric/lakehouse_64_item.svg",
  fabric_warehouse:           "/icons/fabric/data_warehouse_64_item.svg",
  fabric_sql_database:        "/icons/fabric/sql_database_64_item.svg",
  fabric_onelake:             "/icons/fabric/one_lake_48_color.svg",
  // Engineering
  fabric_pipeline:            "/icons/fabric/pipeline_64_item.svg",
  fabric_dataflow:            "/icons/fabric/dataflow_gen2_64_item.svg",
  fabric_notebook:            "/icons/fabric/notebook_64_item.svg",
  // Analytics & AI
  fabric_semantic_model:      "/icons/fabric/semantic_model_64_item.svg",
  fabric_report:              "/icons/fabric/power_bi_48_color.svg",
  fabric_ml_model:            "/icons/fabric/data_science_48_color.svg",
  fabric_data_agent:          "/icons/fabric/data_agent_64_item.svg",
  // Real-time Intelligence
  fabric_eventstream:         "/icons/fabric/eventstream_64_item.svg",
  fabric_eventhouse:          "/icons/fabric/event_house_64_item.svg",
  fabric_kql_database:        "/icons/fabric/kql_database_64_item.svg",
  // Governance
  azurerm_purview_account:    "/icons/fabric/purview_48_color.svg",
  azurerm_policy_assignment:  "/icons/azure/10316-icon-service-Policy.svg",
  fabric_domain:              "/icons/azure/10007-icon-service-Resource-Groups.svg",
};
